import type { AppState, AppEvent } from '~/orderingApp/types/state/app';

export const initialState: AppState = {
  autoNavigate: true,
  isScrolling: false,
  isZoomedIn: false,
  nextPriceChange: undefined,
  returnFocusTo: undefined,
};

export const appReducer = (prevState: AppState = initialState, event: AppEvent) => {
  let nextState = { ...prevState };
  switch (event.type) {
    case 'zoomChanged':
      nextState.isZoomedIn = event.isZoomedIn;
      break;
    case 'setIsScrolling':
      nextState.isScrolling = event.isScrolling;
      break;
    case 'setAutoNavigate':
      nextState.autoNavigate = event.autoNavigate;
      break;
    case 'setReturnFocusTo':
      nextState.returnFocusTo = event.returnFocusTo;
      break;
    case 'ordering.resetApp':
      nextState = { ...initialState };
      break;
    case 'ordering.queuePriceChangeRefetch':
      nextState.nextPriceChange = event.nextPriceChange;
      break;
    default:
      break;
  }
  return nextState;
};
